module.exports = __webpack_public_path__ + "static/media/favorite-icon.567170f4.svg";